<template>
  <div
    v-clickoutside="close"
    :class="['dropdown-wrap', { open: isOpened }]"
  >
    <modal-header-white
      v-if="isMobile && isOpened"
      :device-type="'mobile'"
      :label="mobileTitle"
      @closed="close"
    />

    <div
      class="dropdown-field"
      @click="toggleOpened"
    >
      <span class="dropdown-field__title">
        {{ getSelectedItemTitle() }}
      </span>
    </div>
    <ul class="dropdown-list">
      <li
        v-for="(item, index) in items"
        :key="index"
        :class="{ selected: item.value === selectedItem }"
        @click="selectItem(item.value)"
      >
        {{ item.title }}
      </li>
    </ul>
  </div>
</template>

<script>
  import Clickoutside from 'element-ui/src/utils/clickoutside'
  import ModalHeaderWhite from 'components/Modal/ModalHeaderWhite'

  export default {
    directives: {
      Clickoutside
    },
    components: {
      ModalHeaderWhite
    },
    props: {
      items: {
        type: Array,
        default: () => []
      },
      selectedItem: {
        type: String,
        default: ''
      },
      selectedTitle: {
        type: String,
        default: null
      },
      deviceType: {
        type: String,
        default: null
      },
      mobileTitle: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      }
    },
    data() {
      return {
        isOpened: false,
        selected: this.selectedItem
      }
    },
    computed: {
      isMobile() {
        return this.deviceType === 'mobile'
      }
    },
    watch: {
      selectedItem() {
        this.selected = this.selectedItem
      }
    },
    methods: {
      toggleOpened() {
        this.isOpened = !this.isOpened
        if (this.isOpened && !this.isMobile && this.title) {
          this.selected = this.title
        } else {
          this.selected = this.selectedItem
        }
      },

      getSelectedItemTitle() {
        if (this.selectedTitle !== null) {
          return this.selectedTitle
        }

        const item = this.items.find((x) => x.value === this.selectedItem)
        if (item && item.value !== '') {
          return item.title
        }

        return this.title
      },

      close() {
        this.isOpened = false
        this.selected = this.selectedItem
      },

      selectItem(item) {
        this.close()
        this.$emit('select', item)
      }
    }
  }
</script>

<style
  lang="scss"
  scoped
  rel="stylesheet/scss"
>
  @import '~assets/styles/common.scss';
  @import '~assets/styles/components/dropdown.scss';
</style>
